(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ovela-gallery-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ovela-video-carousel')) {
    customElements.define('ovela-video-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ov-gallery-videos__track');
        if (!this.track) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.prev = this.querySelector('[data-video-prev]');
        this.next = this.querySelector('[data-video-next]');
        this.update = () => {
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
        };
        this.move = direction => {
          const card = this.track.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        this.prev?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.addEventListener('play', event => {
          this.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
        }, { ...options, capture: true });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const card = event.target.closest('.ov-gallery-videos__card');
          if (card) this.track.scrollTo({left: this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'instant'});
        }, options);
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.track);
        this.visibility = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
        }, {root: this.track, threshold: 0});
        this.querySelectorAll('video').forEach(video => this.visibility.observe(video));
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.visibility?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
